<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<div id="content" class="app-content box-shadow-3 scroll-x">
				<!-- Optional navbar at top of page -->
				<div class="navbar navbar-light bg-light b-b">
					<div class="flex navbar-breadcrumbs">
						<a v-if="classObj && assessment" class="text-muted" :href="`/#/class/${classObj.id}`">{{
							classObj.name
						}}</a>
						<i
							v-if="classObj && assessment && deliveries.length == 1"
							class="far fa-fw fa-angle-right text-muted"
						/>
						<a
							v-if="classObj && assessment"
							class="text-muted"
							:href="`/#/class/${classObj.id}/assessment/${assessment.id}`"
							>{{ assessment.name }}</a
						>
						<i
							v-if="classObj && assessment && deliveries.length == 1"
							class="far fa-fw fa-angle-right text-muted"
						/>
						<span v-if="classObj && assessment && deliveries.length == 1">{{ deliveries[0].name }}</span>
						<i v-if="classObj && assessment" class="far fa-fw fa-angle-right text-muted" />
						<span v-if="classObj && assessment">Class Results</span>
						<span v-if="!(classObj && assessment)">
							<loading type="inline-header" />
						</span>
					</div>
					<a v-if="classObj && assessment" class="btn-nav-topright b-l ml-0" @click="exportCSV">
						<div v-tippy title="Export to CSV">
							<i class="fas fa-file-export fa-lg fa-fw" />
						</div>
					</a>
					<a
						v-if="classObj && assessment"
						class="btn-nav-topright b-l ml-0"
						:href="`/#/class/${classObj.id}/assessment/${assessment.id}`"
					>
						<div>
							<i class="fas fa-arrow-alt-left fa-fw" />
							Back
						</div>
					</a>
					<a class="btn-nav-topright b-l ml-0" href="/#/landing">
						<div>
							<i class="fas fa-th-large fa-fw" />
							Home
						</div>
					</a>
				</div>

				<div class="content-main">
					<div class="b-b nav-active-bg card-header">
						<ul class="nav nav-tabs card-header-tabs">
							<li class="nav-item">
								<a class="nav-link" :class="{ active: showTab == 1 }" @click="showTab = 1">Scores</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" :class="{ active: showTab == 2 }" @click="showTab = 2"
									>Statistics</a
								>
							</li>
							<li v-if="deliveries && deliveries.length > 1" class="nav-item">
								<a class="nav-link" :class="{ active: showTab == 3 }" @click="showTab = 3">Progress</a>
							</li>
						</ul>
					</div>

					<!-- Tab 1-->
					<div class="row m-0 align-items-stretch" v-if="classObj" v-show="showTab == 1">
						<!-- Students -->
						<div
							v-for="(deliv, i) in deliveries"
							:key="deliv.id"
							class="col-12 padding pt-4"
							:class="{ 'pb-0': i < deliveries.length - 1 }"
						>
							<h5 v-if="!deliveryID" class="mb-3">{{ deliv.name }}</h5>
							<div class="flex card box mb-0">
								<table>
									<tr>
										<th class="b-b pl-3 v-bottom" style="width: 15%">
											Students
											<span class="text-muted text-sm _500">
												({{ deliv.shown_responses }} out of {{ deliv.responses.length }})
											</span>
										</th>
										<th class="b-b pl-3 v-bottom" style="width: 8%">ID</th>
										<th class="b-b px-2 text-center"></th>
										<th
											class="b-b px-2 text-center border-right"
											v-for="(trait, i) in realTraits"
											:key="trait.id"
										>
											{{ trait.name }}
										</th>
										<th class="b-b text-center">Final</th>
									</tr>
									<tbody
										v-for="resp in deliv.responses"
										v-if="resp.first_score"
										:key="`row-${resp.id}-1`"
										class="clickable"
										@click="openScore(resp)"
									>
										<tr class="b-t">
											<td class="b-b b-r pl-3" :rowspan="resp.num_scores">
												<i class="fas fa-lg fa-user mr-2"></i>
												<span>{{ resp.reverse_student_name }}</span>
											</td>
											<td class="b-b pl-3" :rowspan="resp.num_scores">
												<span>{{ resp.student_ref_id }}</span>
											</td>
											<td class="b-l text-center text-muted">
												<i
													v-if="scoreTypeIconClass(1)"
													class="far fa-lg"
													:class="scoreTypeIconClass(1)"
													v-tippy
													:title="scoreTypeTooltip(resp.first_score, 1)"
												></i>
												<i
													v-if="!scoreTypeIconClass(1)"
													class="material-icons"
													style="font-size: 28px; line-height: 30px"
													v-tippy
													:title="scoreTypeTooltip(resp.first_score, 1)"
													>{{ scoreTypeIcon(1) }}</i
												>
											</td>
											<td
												v-for="col in resp.first_score.trait_scores"
												:key="col.trait_id"
												class="text-md text-center text-muted border-right"
											>
												{{ col.score }}
											</td>
											<td class="b-l b-b text-center" :rowspan="resp.num_scores">
												<div v-if="resp.weighted_score != undefined" class="text-lg">
													{{ fs.fixed012d(resp.weighted_score) }}
												</div>
												<div
													v-if="resp.weighted_score == undefined"
													class="text-lg text-very-muted _600"
												>
													—
												</div>
											</td>
										</tr>
										<tr
											v-if="resp.reliability_score"
											:key="`row-${resp.id}-2`"
											:class="{ 'b-b': !resp.resRequired }"
										>
											<td
												class="text-center"
												:class="{
													'text-muted': !resp.second_score || resp.resRequired,
													'final-score': resp.second_score && !resp.resRequired,
												}"
											>
												<i
													v-if="scoreTypeIconClass(2)"
													class="far fa-lg"
													:class="scoreTypeIconClass(2)"
													v-tippy
													:title="scoreTypeTooltip(resp.second_score, 2)"
												></i>
												<i
													v-if="!scoreTypeIconClass(2)"
													class="material-icons"
													style="font-size: 28px; line-height: 30px"
													v-tippy
													:title="scoreTypeTooltip(resp.second_score, 2)"
													>{{ scoreTypeIcon(2) }}</i
												>
											</td>
											<template v-if="resp.second_score">
												<td
													v-for="col in resp.second_score.trait_scores"
													:key="col.trait_id"
													class="text-md text-center"
													:class="{
														'text-muted': resp.resRequired,
														_600: !resp.resRequired,
														'final-score': !resp.resRequired,
													}"
												>
													{{ col.score }}
												</td>
											</template>
											<td
												v-if="!resp.second_score"
												v-for="trait in realTraits"
												:key="trait.id"
												class="text-md text-center _600 text-very-muted border-right"
											>
												—
											</td>
										</tr>
										<tr
											v-if="resp.resRequired"
											:key="`row-${resp.id}-3`"
											:class="{ 'b-b': resp.resRequired }"
										>
											<td
												class="text-center"
												:class="{
													'text-muted': !resp.res_score,
													'final-score': resp.res_score,
												}"
											>
												<i
													v-if="scoreTypeIconClass(3)"
													class="far fa-lg"
													:class="scoreTypeIconClass(3)"
													v-tippy
													:title="scoreTypeTooltip(resp.res_score, 3)"
												></i>
												<i
													v-if="!scoreTypeIconClass(3)"
													class="material-icons"
													style="font-size: 28px; line-height: 30px"
													v-tippy
													:title="scoreTypeTooltip(resp.res_score, 3)"
													>{{ scoreTypeIcon(3) }}</i
												>
											</td>
											<template v-if="resp.res_score">
												<td
													v-for="col in resp.res_score.trait_scores"
													:key="col.trait_id"
													class="text-md text-center _600 final-score"
												>
													{{ col.score }}
												</td>
											</template>
											<td
												v-if="!resp.res_score"
												v-for="trait in realTraits"
												:key="trait.id"
												class="text-md text-center _600 text-very-muted"
											>
												—
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>

					<!-- Tab 2 -->
					<div class="row m-0 align-items-stretch" v-if="classObj" v-show="showTab == 2">
						<div
							v-for="(trait, i) in realTraits"
							:key="trait.id"
							class="col-12 padding pt-4"
							:class="{ 'pb-0': i < realTraits.length - 1 }"
						>
							<h5 class="mb-3">{{ trait.name }}</h5>
							<div class="flex card box mb-0">
								<div class="row mb-0 p-3">
									<div
										class="col-4 col-sm-2 d-flex flex-column justify-content-center align-items-center"
									>
										<div class="text-center">
											<h1 :class="{ 'text-very-muted': !(trait.irr_exact > 0) }">
												{{ fs.fixedPercent1d(trait.irr_exact) }}
											</h1>
											<h6 class="text-muted mb-0">Agreement</h6>
											<div class="text-muted">(exact)</div>
										</div>
									</div>
									<div
										class="col-4 col-sm-2 d-flex flex-column justify-content-center align-items-center"
									>
										<div class="text-center">
											<h1 :class="{ 'text-very-muted': !(trait.irr_exact_adj > 0) }">
												{{ fs.fixedPercent1d(trait.irr_exact_adj) }}
											</h1>
											<h6 class="text-muted mb-0">Agreement</h6>
											<div class="text-muted">(exact/adj.)</div>
										</div>
									</div>
									<div class="col-2 col-sm-1">
										<table style="height: 100%" class="text-md">
											<tr style="height: 10%"></tr>
											<tr
												style="height: 16%"
												class="text-center"
												:class="{
													'text-danger': trait.adj.nonadj_high > 0,
													'text-very-muted': trait.adj.nonadj_high == 0,
												}"
												v-tippy
												:title="nonadjHighTooltip(trait.adj.nonadj_high)"
											>
												<td>
													<i class="far fa-chevron-double-up mr-2"></i>
												</td>
												<td>{{ trait.adj.nonadj_high }}</td>
											</tr>
											<tr
												style="height: 16%"
												class="text-center"
												:class="{
													'text-warning': trait.adj.adj_high > 0,
													'text-very-muted': trait.adj.adj_high == 0,
												}"
												v-tippy
												:title="adjHighTooltip(trait.adj.adj_high)"
											>
												<td>
													<i class="far fa-chevron-up mr-2"></i>
												</td>
												<td>{{ trait.adj.adj_high }}</td>
											</tr>
											<tr
												style="height: 16%"
												class="text-center"
												:class="{
													'text-success': trait.adj.exact > 0,
													'text-very-muted': trait.adj.exact == 0,
												}"
												v-tippy
												:title="exactTooltip(trait.adj.exact)"
											>
												<td>
													<i class="far fa-check mr-2"></i>
												</td>
												<td>{{ trait.adj.exact }}</td>
											</tr>
											<tr
												style="height: 16%"
												class="text-center"
												:class="{
													'text-warning': trait.adj.adj_low > 0,
													'text-very-muted': trait.adj.adj_low == 0,
												}"
												v-tippy
												:title="adjLowTooltip(trait.adj.adj_low)"
											>
												<td>
													<i class="far fa-chevron-down mr-2"></i>
												</td>
												<td>{{ trait.adj.adj_low }}</td>
											</tr>
											<tr
												style="height: 16%"
												class="text-center"
												:class="{
													'text-danger': trait.adj.nonadj_low > 0,
													'text-very-muted': trait.adj.nonadj_low == 0,
												}"
												v-tippy
												:title="nonadjLowTooltip(trait.adj.nonadj_low)"
											>
												<td>
													<i class="far fa-chevron-double-down mr-2"></i>
												</td>
												<td>{{ trait.adj.nonadj_low }}</td>
											</tr>
											<tr style="height: 10%"></tr>
										</table>
									</div>
									<div class="col-12 col-sm-7 pt-4">
										<canvas v-chartjs="trait.chartData" style="width: 100%; height: 180px"></canvas>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Tab 3-->
					<div class="row m-0 align-items-stretch" v-if="classObj" v-show="showTab == 3">
						<div class="col-12 padding py-4">
							<div class="flex card box mb-0">
								<table>
									<tr>
										<th class="b-b pl-3 v-bottom">
											Students
											<span class="text-muted text-sm _500">({{ workStats.length }})</span>
										</th>
										<th class="b-b pl-3 v-bottom">ID</th>
										<th v-for="deliv in deliveries" :key="deliv.id" class="b-b px-2 text-center">
											{{ deliv.name }}
										</th>
									</tr>
									<template v-for="(stat, i) in workStats">
										<tr :key="`progressrow-${i}`" class="b-t">
											<td class="b-b b-r pl-3">
												<i class="fas fa-lg fa-user mr-2"></i>
												<span>{{ stat.student.full_name }}</span>
											</td>
											<td class="b-b pl-3">
												<span>{{ stat.student.ref_id }}</span>
											</td>
											<td
												v-for="(resp, i) in stat.responseColumns"
												:key="i"
												class="b-l b-b text-center p-0"
												:class="{ clickable: resp.media && resp.media.length }"
												@click="openScore(resp)"
											>
												<div
													v-if="resp.id"
													class="d-flex flex-row align-items-center"
													v-tippy="{ theme: 'popover', html: `#prog-${stat.student.id}` }"
												>
													<div
														v-if="resp.id && resp.weighted_change != undefined"
														class="flex text-right text-lg pr-1 nowrap"
														:class="{ [progressClass(resp.weighted_change)]: true }"
													>
														{{ fs.fixed012d(resp.weighted_score) }}
													</div>
													<div
														v-if="resp.id && resp.weighted_change != undefined"
														class="flex text-left text-md pl-1"
														:class="{ [progressClass(resp.weighted_change)]: true }"
													>
														<i
															v-if="progressIcon(resp.weighted_change)"
															class="far"
															:class="{ [progressIcon(resp.weighted_change)]: true }"
														/>
														<span
															v-if="!progressIcon(resp.weighted_change)"
															class="text-muted _600"
															>—</span
														>
													</div>
													<div
														v-if="resp.id && resp.weighted_change == undefined"
														class="flex text-lg text-center"
													>
														{{ fs.fixed012d(resp.weighted_score) }}
													</div>
												</div>
												<div v-if="!resp.id" class="flex text-lg text-very-muted _600">—</div>
												<div class="d-none p-0" :id="`prog-${stat.student.id}`">
													<progress-score
														:responses="stat.responseColumns"
														:rubric="rubric"
														:deliveries="deliveries"
													></progress-score>
												</div>
											</td>
										</tr>
									</template>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.student-row {
	height: 42px;
}
.text-xl {
	font-size: 2rem;
}
.final-score {
	background-color: rgb(34, 182, 110, 0.1);
}
.anim-rotate {
	transition: transform 0.2s ease-out;
}
.rotate-90 {
	transform: rotate(-90deg);
}
.clickable {
	cursor: pointer;
}
.clickable:hover {
	background-color: rgba(0, 0, 0, 0.05);
}
</style>

<script>
import ReportingService from "@/services/ReportingService";
import AssessmentService from "@/services/AssessmentService";
import ResponseMediaService from "@/services/ResponseMediaService";
import ViewingDriver from "@/services/ScoringDrivers/ViewingDriver";
import exporter from "@/services/Exporters/ClassResults.js";
import ProgressScore from "@/components/ProgressScore";
import Notie from "@/services/NotieService";
import draggable from "vuedraggable";
import fs from "@/services/FormatService";
import store from "@/services/Store";
import BB from "bluebird";
import $ from "jquery";

export default {
	name: "ClassResults",

	props: ["user"],

	data() {
		return {
			fs: fs,
			assessment: null,
			item: null,
			deliveryID: null,
			rubric: null,
			classObj: null,
			deliveries: [],

			showTab: store.getDefault(this, "classResults.tab", 1),

			workStats: null,
		};
	},
	components: { draggable, ProgressScore },
	watch: {
		showTab() {
			store.set(this, "classResults.tab", this.showTab);
		},
	},
	computed: {
		realTraits() {
			if (!this.rubric && this.rubric.traits) {
				return [];
			}
			return _.filter(this.rubric.traits, (trait) => {
				return !trait.separator;
			});
		},
	},
	created() {
		this.deliveryID = this.$route.query.d;
		this.loadData();
	},
	methods: {
		loadData() {
			let classID = this.$route.params.classID;
			let asmtID = this.$route.params.asmtID;
			return BB.props({
				assessment: AssessmentService.getClassAssessment(classID, asmtID),
				work: AssessmentService.getClassAssessmentWork(classID, asmtID),
			})
				.then((resps) => {
					this.assessment = resps.assessment.data.assessment;
					this.item = resps.assessment.data.item;
					this.rubric = this.item.rubric;
					this.rubric.unweighted = _.every(this.rubric.traits, {
						weight: 0,
					});
					this.classObj = resps.assessment.data.class;

					if (this.deliveryID) {
						this.deliveries = _.filter(this.classObj.deliveries, {
							id: this.deliveryID,
						});
					} else {
						this.deliveries = _.sortBy(this.classObj.deliveries, "sequence");
					}

					if (this.deliveryID) {
						this.delivery = _.find(this.classObj.deliveries, {
							id: this.deliveryID,
						});
					}

					this.workStats = resps.work.data.stats;
					console.log(this.workStats);
					this.workStats = _.sortBy(this.workStats, ["student.last_name", "student.first_name"]);
					this.constructScoreRows(this.workStats);
					this.constructTraitRows(this.workStats);
					if (this.deliveries.length > 1) {
						this.constructProgressRows(this.workStats);
					}
				})
				.catch((err) => {
					console.log(err);
					Notie.error("Failed to load assessment details", err);
				});
		},

		constructScoreRows(stats) {
			_.each(this.deliveries, (deliv) => {
				deliv.responses = [];
				deliv.shown_responses = 0;
				_.each(stats, (stat, i) => {
					let resp = _.find(stat.responses, {
						delivery_id: deliv.id,
					});
					if (resp) {
						resp.num_scores = 0;
						resp.student_name = stat.student.full_name;
						resp.reverse_student_name = fs.nameReverse(stat.student);
						resp.student_ref_id = stat.student.ref_id;
						resp.first_score = _.find(resp.scores, {
							score_type: 1,
						});
						if (resp.first_score) {
							resp.num_scores++;
							deliv.shown_responses++;
						}
						resp.second_score = _.find(resp.scores, {
							score_type: 2,
						});
						if (resp.second_score) {
							resp.num_scores++;
						}
						resp.res_score = _.find(resp.scores, {
							score_type: 3,
						});

						if (resp.res_score || (resp.second_score && resp.state != 10)) {
							resp.num_scores++;
							resp.resRequired = true;
						}

						if (resp.num_scores == 1) {
							resp.num_scores = 2;
						}

						if (resp.state == 10) {
							if (resp.res_score) {
								resp.weighted_score = this.setWeightedScore(resp.res_score);
								resp.final_score = resp.res_score;
							} else if (resp.second_score) {
								resp.weighted_score = this.setWeightedScoreAverage(resp.first_score, resp.second_score);
								resp.final_score = {
									trait_scores: this.getWeightedScoreTraits(resp.first_score, resp.second_score),
								};
							} else if (resp.first_score) {
								resp.weighted_score = this.setWeightedScore(resp.first_score);
								resp.final_score = resp.first_score;
							}
						}
						deliv.responses[i] = resp;
					} else {
						deliv.responses[i] = {
							scores: [],
							num_scores: 0,
						};
					}
					i++;
				});
			});
		},

		setWeightedScore(scoreObj) {
			let weighted_score = 0;
			_.each(scoreObj.trait_scores, (ts) => {
				if (this.rubric.unweighted) {
					weighted_score += ts.score;
				} else {
					let trait = _.find(this.rubric.traits, {
						id: ts.trait_id,
					});
					weighted_score += ts.score * trait.weight;
				}
			});
			return weighted_score;
		},

		setWeightedScoreAverage(scoreObj1, scoreObj2) {
			let weighted_score = 0;
			_.each(scoreObj1.trait_scores, (score1) => {
				const score2 = _.find(scoreObj2.trait_scores, { trait_id: score1.trait_id });
				if (!score2) {
					console.log("Scores did not match", scoreObj1, scoreObj2);
					return;
				}
				if (this.rubric.unweighted) {
					weighted_score += (score1.score + score2.score) / 2;
				} else {
					let trait = _.find(this.rubric.traits, {
						id: score1.trait_id,
					});
					weighted_score += ((score1.score + score2.score) / 2) * trait.weight;
				}
			});
			return weighted_score;
		},

		getWeightedScoreTraits(scoreObj1, scoreObj2) {
			let trait_scores = [];
			_.each(scoreObj1.trait_scores, (score1) => {
				const score2 = _.find(scoreObj2.trait_scores, { trait_id: score1.trait_id });
				if (!score2) {
					console.log("Scores did not match", scoreObj1, scoreObj2);
					return;
				}

				let avg = 0;
				if (this.rubric.unweighted) {
					avg = (score1.score + score2.score) / 2;
				} else {
					let trait = _.find(this.rubric.traits, {
						id: score1.trait_id,
					});
					avg = ((score1.score + score2.score) / 2) * trait.weight;
				}
				trait_scores.push({ trait_id: score1.trait_id, score: avg });
			});
			return trait_scores;
		},

		constructProgressRows(stats) {
			_.each(stats, (stat, i) => {
				stat.responseColumns = [];
				_.each(this.deliveries, (deliv, i) => {
					let resp = _.find(stat.responses, {
						delivery_id: deliv.id,
					});

					let previousResp = null;
					if (i > 0) {
						previousResp = _.find(stat.responses, {
							delivery_id: this.deliveries[i - 1].id,
						});
					}

					if (resp && resp.final_score) {
						if (previousResp) {
							resp.weighted_change = resp.weighted_score - previousResp.weighted_score;
							_.each(resp.final_score.trait_scores, (ts) => {
								let prev = _.find(previousResp.final_score.trait_scores, { trait_id: ts.trait_id });
								if (prev) {
									ts.delta = ts.score - prev.score;
								}
							});
						}
						stat.responseColumns.push(resp);
						previousResp = resp;
					} else {
						stat.responseColumns.push({});
						previousResp = null;
					}

					this.$set(stat, "showDetails", false);
				});
			});
		},

		constructTraitRows(stats) {
			_.each(this.rubric.traits, (trait) => {
				if (trait.separator) {
					return;
				}

				trait.adj = {
					nonadj_low: 0,
					adj_low: 0,
					exact: 0,
					adj_high: 0,
					nonadj_high: 0,
				};
				trait.irr_exact = 0;
				trait.irr_exact_adj = 0;
				trait.irr_total = 0;
				trait.fd = {};

				_.each(this.deliveries, (deliv) => {
					_.each(stats, (stat, i) => {
						let resp = _.find(stat.responses, {
							delivery_id: deliv.id,
						});
						if (!resp) {
							return;
						}

						if (resp.first_score && resp.second_score) {
							trait.irr_total++;

							let fts = _.find(resp.first_score.trait_scores, {
								trait_id: trait.id,
							});
							let sts = _.find(resp.second_score.trait_scores, {
								trait_id: trait.id,
							});
							if (!(fts && sts)) {
								return;
							}

							//Adjacency counts && agreement
							let diff = fts.score - sts.score;
							if (diff < -1) {
								trait.adj.nonadj_low++;
							} else if (diff < 0) {
								trait.adj.adj_low++;
								trait.irr_exact_adj++;
							} else if (diff == 0) {
								trait.adj.exact++;
								trait.irr_exact++;
								trait.irr_exact_adj++;
							} else if (diff <= 1) {
								trait.adj.adj_high++;
								trait.irr_exact_adj++;
							} else {
								trait.adj.nonadj_high++;
							}
						}

						//FD
						_.each(resp.scores, (score) => {
							let ts = _.find(score.trait_scores, {
								trait_id: trait.id,
							});
							if (!ts) {
								return;
							}

							if (!trait.fd[ts.score]) {
								trait.fd[ts.score] = 0;
							}
							trait.fd[ts.score]++;
						});
					});
				});

				trait.irr_exact = (100 * trait.irr_exact) / trait.irr_total;
				trait.irr_exact_adj = (100 * trait.irr_exact_adj) / trait.irr_total;

				let labels = [];
				let data = [];
				let counts = [];

				let fd_total = 0;
				_.each(trait.fd, (sp) => {
					fd_total += sp;
				});

				var step = 1;
				if (trait.use_half_points) {
					step = 0.5;
				}

				for (var i = trait.min; i <= trait.max; i += step) {
					let count = trait.fd[i];
					if (count == undefined) {
						count = 0;
					}
					let per = (100 * count) / fd_total;
					labels.push(i);
					counts.push({ count: count, total: fd_total });
					data.push(+(Math.round(per + "e+1") + "e-1"));
				}

				trait.chartData = {
					type: "bar",
					data: {
						labels: labels,
						datasets: [
							{
								xAxisID: "sp",
								yAxisID: "freq",
								backgroundColor: "#4968e733",
								borderColor: "#4968e755",
								borderWidth: 2,
								hoverBackgroundColor: "#4968e777",
								hoverBorderColor: "#4968e7aa",
								hoverBorderWidth: 2,
								data: data,
								counts: counts,
							},
						],
					},
					options: {
						tooltips: {
							mode: "point",
							displayColors: false,
							callbacks: {
								title: (items, data) => {
									let i = items[0].datasetIndex;
									let sp = items[0].xLabel;
									let fullName = data.datasets[i].fullName;
									return `Score point ${sp}`;
								},
								label: (item, data) => {
									let i = item.datasetIndex;
									let j = item.index;
									let count = data.datasets[i].counts[j].count;
									let total = data.datasets[i].counts[j].total;
									let per = data.datasets[i].data[j];
									return `${count} out of ${total} (${per}%)`;
								},
							},
						},
						maintainAspectRatio: false,
						legend: {
							display: false,
						},
						scales: {
							xAxes: [
								{
									id: "sp",
									scaleLabel: {
										display: true,
										labelString: "Score Point",
									},
								},
							],
							yAxes: [
								{
									id: "freq",
									scaleLabel: {
										display: true,
										labelString: "Frequency",
									},
									ticks: {
										suggestedMin: 0,
										suggestedMax: 25,
									},
								},
							],
						},
					},
				};
			});
		},

		toggleDetails(stat) {
			this.$set(stat, "showDetails", !stat.showDetails);
		},

		progressIcon(delta) {
			if (delta < 0) {
				return "fa-chevron-down";
			} else if (delta > 0) {
				return "fa-chevron-up";
			} else {
				return "";
			}
		},

		progressClass(delta) {
			if (delta == undefined) {
				return "";
			}

			if (delta < 0) {
				return "text-danger";
			} else if (delta > 0) {
				return "text-success";
			} else {
				return "text-warning";
			}
		},

		scoreTypeIcon(scoreType) {
			return fs.scoreTypeIcon(scoreType);
		},
		scoreTypeIconClass(scoreType) {
			return fs.scoreTypeIconClass(scoreType);
		},
		scoreTypeStr(scoreType) {
			let ret = fs.scoreTypeName(scoreType);
			if (this.hasUser) {
				return `${ret}:`;
			} else {
				return ret;
			}
		},
		scoreTypeTooltip(score, scoreType) {
			let tooltip = `<strong>${this.scoreTypeStr(scoreType)} Score</strong>`;
			if (score) {
				tooltip += `<br /><span class="text-muted"><i class="fal fa-clock"></i> ${fs.fullDate(
					score.created_at
				)}</span>`;
			} else {
				tooltip += `<br /><span class="text-muted">Not yet applied</span>`;
			}

			return tooltip;
		},
		getTraitName(traitID) {
			let trait = _.find(this.rubric.traits, { id: traitID });
			if (trait) {
				return trait.name;
			} else {
				return "?";
			}
		},

		openScore(response) {
			if (!response.media || response.media.length == 0) {
				console.log("No response to display");
				return;
			}

			let aid = response.assessment_id;
			let iid = response.item_id;
			let cid = response.class_id;
			let did = response.delivery_id;
			let rid = response.id;
			ViewingDriver.enter(this, aid, iid, rid);
		},

		exportCSV() {
			exporter.exportCSV(this);
		},

		nonadjHighTooltip(num) {
			return `<div>Non-adjacent high</div>
			<div class="text-muted text-xxs">Your score (the first score) was <strong>more than 1 point higher</strong><br />than the second score in ${num} ${
				num == 1 ? "case" : "cases"
			}</div>`;
		},

		adjHighTooltip(num) {
			return `<div>Adjacent high</div>
			<div class="text-muted text-xxs">Your score (the first score) was <strong>1 point higher</strong><br />than the second score in ${num} ${
				num == 1 ? "case" : "cases"
			}</div>`;
		},

		exactTooltip(num) {
			return `<div>Exact</div>
			<div class="text-muted text-xxs">Your score (the first score) was <strong>exactly the same</strong><br />as the second score in ${num} ${
				num == 1 ? "case" : "cases"
			}</div>`;
		},

		adjLowTooltip(num) {
			return `<div>Adjacent low</div>
			<div class="text-muted text-xxs">Your score (the first score) was <strong>1 point lower</strong><br />than the second score in ${num} ${
				num == 1 ? "case" : "cases"
			}</div>`;
		},

		nonadjLowTooltip(num) {
			return `<div>Non-adjacent low</div>
			<div class="text-muted text-xxs">Your score (the first score) was <strong>more than 1 point lower</strong><br />than the second score in ${num} ${
				num == 1 ? "case" : "cases"
			}</div>`;
		},
	},
};
</script>





// WEBPACK FOOTER //
// src/vues/Classes/ClassResults.vue